import { MAP_TYPES } from '@deck.gl/carto';

const STATE_SOCIOECONOMIC_SOURCE_ID = 'stateSocioeconomicSource';

function source(year, socioeconomicFactor) {
  year = parseInt(year);

  return {
    id: STATE_SOCIOECONOMIC_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data: `
      SELECT
        ST_X(ST_CENTROID(geom)) AS lng, ST_Y(ST_CENTROID(geom)) AS lat, year, name, ${socioeconomicFactor}
      FROM
        carto-dw-ac-cn5bemsi.shared.state_observations AS observations
      JOIN
        carto-dw-ac-cn5bemsi.shared.state_geometries AS geometry ON observations.statename = geometry.name
      WHERE
        observations.year = ${year}
    `,
    queryParameters: {
      year,
      socioeconomicFactor,
    },
  };
}

export default source;
